<template>
  <div id="center">
    <div class="up">
      <div class="bg-color-black item" v-for="item in titleItem" :key="item.title">
        <p class="ml-3 colorBlue fw-b fs-xl">{{ item.title }}</p>
        <div>
          <dv-digital-flop class="dv-dig-flop ml-1 mt-2 pl-3" :config="item.number" />
        </div>
      </div>
    </div>
    <div class="down">
      <div class="ranking bg-color-black">
        <span>
          <icon name="chart-pie" class="text-icon"></icon>
        </span>
        <span class="fs-xl text mx-2 mb-1 pl-3">研判动态</span>
        <dv-scroll-ranking-board class="dv-scr-rank-board mt-1" :config="ranking" />
      </div>
      <div class="percent">
        <div class="item bg-color-black">
          <span>今日处置完成率</span>
          <CenterChart :id="rate[0].id" :tips="rate[0].tips" :colorObj="rate[0].colorData" />
        </div>
        <div class="item bg-color-black">
          <span>今日处置达标率</span>
          <CenterChart :id="rate[1].id" :tips="rate[1].tips" :colorObj="rate[1].colorData" />
        </div>
        <div class="water">
          <dv-water-level-pond class="dv-wa-le-po" :config="water" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CenterChart from '@/components/echart/center/centerChartRate'

export default {
  data() {
    return {
      drawTiming: null,
      titleItem: [
        {
          title: '辖区船舶数',
          number: {
            number: [16120],
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 26
            }
          }
        },
        {
          title: '黄码船舶数',
          number: {
            number: [360],
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 26,
              fill: '#ffc107'
            }
          }
        },
        {
          title: '红码船舶数',
          number: {
            number: [32],
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 26,
              fill: '#ff0000'
            }
          }
        },
        {
          title: '执法人员数',
          number: {
            number: [1450],
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 26
            }
          }
        },
        {
          title: '执法车辆数',
          number: {
            number: [106],
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 26
            }
          }
        },
        {
          title: '执法船艇数',
          number: {
            number: [100],
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 26
            }
          }
        }
      ],
      ranking: {
        data: [
          {
            name: '大数据比对研判',
            value: 55
          },
          {
            name: '海事通推送',
            value: 120
          },
          {
            name: '智能卡口推送',
            value: 78
          },
          {
            name: '基于电子围栏研判',
            value: 66
          },
          {
            name: 'AI视频分析研判',
            value: 80
          },
          {
            name: '其他智能设备研判',
            value: 80
          }
        ]
      },
      water: {
        data: [10, 24],
        shape: 'roundRect',
        formatter: '{value}%',
        waveNum: 3
      },
      // 通过率和达标率的组件复用数据
      rate: [
        {
          id: 'centerRate1',
          tips: 95,
          colorData: {
            textStyle: '#3fc0fb',
            series: {
              color: ['#00bcd44a', 'transparent'],
              dataColor: {
                normal: '#03a9f4',
                shadowColor: '#97e2f5'
              }
            }
          }
        },
        {
          id: 'centerRate2',
          tips: 80,
          colorData: {
            textStyle: '#67e0e3',
            series: {
              color: ['#faf3a378', 'transparent'],
              dataColor: {
                normal: '#ff9800',
                shadowColor: '#fcebad'
              }
            }
          }
        }
      ]
    }
  },
  components: {
    CenterChart
  },
  mounted() {
    this.drawTimingFn()
  },
  beforeDestroy() {
    clearInterval(this.drawTiming)
  },
  methods: {
    drawTimingFn() {
      this.drawTiming = setInterval(() => {
        this.changeNumber()
      }, 6000)
    },
    changeNumber() {
      this.titleItem.forEach((item, index) => {
        if (index < 3) {
          item.number.number[0] += Math.round(Math.random() * (10 - index))
          item.number = { ...item.number }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#center {
  display: flex;
  flex-direction: column;
  .up {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    .item {
      border-radius: 6px;
      padding-top: 8px;
      margin-top: 8px;
      width: 32%;
      height: 70px;
      .dv-dig-flop {
        width: 150px;
        height: 30px;
      }
    }
  }
  .down {
    padding: 6px 4px;
    padding-bottom: 0;
    width: 100%;
    display: flex;
    height: 255px;
    justify-content: space-between;
    .bg-color-black {
      border-radius: 5px;
    }
    .ranking {
      padding: 10px;
      width: 50%;
      .dv-scr-rank-board {
        height: 225px;
      }
    }
    .percent {
      width: 49%;
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 50%;
        height: 120px;
        span {
          margin-top: 8px;
          font-size: 14px;
          display: flex;
          justify-content: center;
        }
      }
      .water {
        width: 100%;
        .dv-wa-le-po {
          height: 120px;
        }
      }
    }
  }
}
</style>
